module.exports = __webpack_public_path__ + "img/ball_2_black.59ede923.png";